<div
  (click)="toggleConnectionsVisibility()"
  [class.clickable]="canBeExpanded"
  class="rounded text-13 connector-menu-item menu-item-with-action-icons"
>
  <!-- Connector icon -->
  <mat-icon class="icon icon-32" svgIcon="{{ menuItemIcon }}" />

  <!-- Not configured connector warning -->
  @if (needsConfigurationForEnvironment) {
    <mat-icon
      blazeTooltip="Connector needs configuration for current environment!"
      class="icon not-configured"
      data-cy="ConnectorMenuItem:needsConfiguration"
      matTooltipPosition="above"
      svgIcon="icon_warning_16"
    />
  }

  <div class="label text-primary-darker" [blazeTooltip]="label">{{ label }}</div>

  <!-- More options menu -->
  @if (isMoreIconVisible) {
    <mat-icon
      (click)="onShowMoreOptions($event)"
      (menuClosed)="updateMenu()"
      [matMenuTriggerFor]="menu"
      [matMenuTriggerData]="{
        linkedTableConnector: linkedTableConnector,
        projectGroupId: projectGroupId(),
      }"
      class="action-icon options-icon"
      data-cy="ConnectorMenuItem:options"
      svgIcon="icon_more_h_16"
    />
  }

  <!-- Add -->
  @if (isAddIconVisible) {
    <mat-icon
      (click)="onCreateConnector()"
      class="action-icon icon-add icon-16"
      data-cy="ConnectorMenuItem:create"
      svgIcon="icon_add_16"
    />
  }

  <!-- Expand, Collapse -->
  @if (canBeExpanded && !isExpanded()) {
    <mat-icon
      class="action-icon"
      data-cy="ConnectorMenuItem:showDatasets"
      svgIcon="icon_chevron_down_16"
    />
  }
  @if (canBeExpanded && isExpanded()) {
    <mat-icon
      class="action-icon"
      data-cy="ConnectorMenuItem:showDatasets"
      svgIcon="icon_chevron_up_16"
    />
  }
</div>

<!-- Datasets associated with the connector -->
<div class="datasets">
  <!-- Actions -->
  @for (actionName of connector?.actions; track actionName) {
    @if (isExpanded()) {
      <blaze-dataset-toggle [actionName]="actionName" [previewOnly]="true" class="dataset" />
    }
  }

  <!-- Datasets -->
  @if (isExpanded()) {
    @for (dataset of connector?.datasets; track dataset.id) {
      <blaze-dataset-toggle
        (showPreview)="onPreview(dataset)"
        [dataset]="dataset"
        [previewOnly]="true"
        class="dataset"
      />
    }
  }

  <!-- Tables -->
  @if (isExpanded()) {
    @for (set of tableConnector?.sets; track set.name) {
      <blaze-dataset-group
        [isAccessLogs]="!!set.isAccessLogs"
        [isChangeTracking]="!!set.isChangeTracking"
        [isSystemTable]="!!set.isSystemTable"
      >
        <ng-container ngProjectAs="title">{{ set.name }}</ng-container>
        <ng-container ngProjectAs="tables">
          @for (table of set.tables; track table.id) {
            <blaze-dataset-toggle
              (deleteDataset)="onDeleteTable(table)"
              (editDataset)="onEditTable(table)"
              (refreshDatasets)="onRefreshTables()"
              [dataset]="table"
              [isBlazeTable]="true"
              [isChangeTracking]="table.isChangeTrackingTable"
              [previewOnly]="true"
              actions="share"
              class="dataset"
            />
          }
        </ng-container>
      </blaze-dataset-group>
    }
    @for (table of tableConnector?.tables; track table.id) {
      <blaze-dataset-toggle
        (deleteDataset)="onDeleteTable(table)"
        (editDataset)="onEditTable(table)"
        (refreshDatasets)="onRefreshTables()"
        [dataset]="table"
        [isBlazeTable]="true"
        [isChangeTracking]="table.isChangeTrackingTable"
        [previewOnly]="true"
        actions="share"
        class="dataset"
      />
    }
  }

  <!-- Linked Tables -->
  @if (isExpanded()) {
    @for (table of linkedTableConnector?.tables; track table.id) {
      <blaze-dataset-toggle
        (editDataset)="onEditTable(table)"
        [dataset]="table"
        [isBlazeTable]="true"
        [isLink]="true"
        [previewOnly]="true"
        class="dataset"
      />
    }
  }
</div>

<mat-menu class="bd-menu options-menu" #menu="matMenu">
  <ng-template
    let-linkedTableConnector="linkedTableConnector"
    let-projectGroupId="projectGroupId"
    matMenuContent
  >
    <button mat-menu-item (click)="onCreateConnector()" data-cy="ConnectorMenuItem:menuCreate">
      <mat-icon class="menu-icon" svgIcon="icon_add_16" />
      <span>Create Connector</span>
    </button>

    @if (isMenuEditConnectorVisible) {
      <button
        mat-menu-item
        (click)="onEditConnector()"
        data-cy="ConnectorMenuItem:menuEditConnector"
      >
        <mat-icon class="menu-icon" svgIcon="icon_edit_16" />
        <span>{{ menuEditConnectorLabel }}</span>
      </button>
    }
    @if (isMenuEditDatasetsVisible) {
      <button mat-menu-item (click)="onEditDatasets()" data-cy="ConnectorMenuItem:menuEditDatasets">
        <mat-icon class="menu-icon" svgIcon="icon_preview_16" />
        <span>Edit Datasets</span>
      </button>
    }

    @if (!!linkedTableConnector && projectGroupId === linkedTableConnector.projectGroupId) {
      <button
        (click)="onConvertToSharedWithinGroup()"
        data-cy="ConnectorMenuItem:shareWithinGroup"
        mat-menu-item
      >
        <mat-icon class="menu-icon" svgIcon="globe" />
        <span>Share Within Group</span>
      </button>
    }

    <button
      (click)="onDeleteConnector()"
      class="!text-warn"
      data-cy="ConnectorMenuItem:menuDelete"
      mat-menu-item
    >
      <mat-icon class="menu-icon" svgIcon="icon_trash_16" />
      <span class="menu-label !text-warn">Delete Connector</span>
    </button>
  </ng-template>
</mat-menu>
